import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { getAllPO, getStatsForFinance } from './purchasesOrdersSlice';
import { toast } from 'react-toastify';

const initialState = {
    loading: false,
    error: null,
}

export const createNewPayment = createAsyncThunk(
    'payments/createNewPayment',
    async ({ 
      payment,
      poId, 
      search, 
      statuses,
      page,
      itemsPerPage
    }, { rejectWithValue, dispatch }) => {
      try {
        await axios.post(`/api/v1/add-payment`, { payment, poId });
        dispatch(getAllPO({ search, statuses, page, itemsPerPage }));
        dispatch(getStatsForFinance({}));
      } catch (error) {
        if ('string' === typeof error.response.data) {
          return rejectWithValue({ error: error.response.data, payment })
        } else {
          return rejectWithValue({ error: error.response.data.errors || error.response.data.error, payment })
        }
      }
    }
)

export const createPaymentsBatch = createAsyncThunk(
  'payments/createPaymentsBatch',
  async ({
    payments,
    search,
    statuses,
    page,
    itemsPerPage
  }, { rejectWithValue, dispatch }) => {
    try {
      for (const item of payments) {
        await axios.post(`/api/v1/add-payment`, { payment: item.payment, poId: item.poId });
      }
      dispatch(getAllPO({ search, statuses, page, itemsPerPage }));
      dispatch(getStatsForFinance({}));
      return { count: payments.length };
    } catch (error) {
      if ('string' === typeof error.response.data) {
        return rejectWithValue({ error: error.response.data })
      } else {
        return rejectWithValue({ error: error.response.data.errors || error.response.data.error })
      }
    }
  }
)

export const updatePaymentsBatch = createAsyncThunk(
  'payments/updatePaymentsBatch',
  async ({
    payments,
    search,
    statuses,
    page,
    itemsPerPage
  }, { rejectWithValue, dispatch }) => {
    try {
      for (const item of payments) {
        await axios.post(`/api/v1/add-payment`, { payment: item.payment, poId: item.poId });
      }
      dispatch(getAllPO({ search, statuses, page, itemsPerPage }));
      dispatch(getStatsForFinance({}));
      return { count: payments.length };
    } catch (error) {
      if ('string' === typeof error.response.data) {
        return rejectWithValue({ error: error.response.data })
      } else {
        return rejectWithValue({ error: error.response.data.errors || error.response.data.error })
      }
    }
  }
)

export const deletePayment = createAsyncThunk(
  'payments/deletePayment',
  async ({ 
    id, 
    poId,
    search, 
    statuses,
    page,
    itemsPerPage
  }, { rejectWithValue, dispatch }) => {
    try {
      await axios.delete(`/api/v1/payment/${id}`, {
        params: {
          poId
        }
      });
      dispatch(getAllPO({ search, statuses, page, itemsPerPage }));
      dispatch(getStatsForFinance({}));
    } catch (error) {
      if ('string' === typeof error.response.data) {
        return rejectWithValue({ error: error.response.data, id })
      } else {
        return rejectWithValue({ error: error.response.data.errors, id })
      }
    }
  }
)

export const paymentsSlice = createSlice({
    name: 'payments',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(createNewPayment.pending, (state) => {
            state.loading = true
        })
        .addCase(createNewPayment.fulfilled, (state) => {
            state.loading = false;
            state.error = null;
            toast.success(`Payment created successfully.`, { position: "bottom-right" })
        })
        .addCase(createNewPayment.rejected, (state, action) => {
            state.loading = false;
            const errorMessage = action.payload?.error || action.error?.message;
            state.error = errorMessage;
            toast.error(
              `Payment can't be created. Error - ${errorMessage}. Arguments: type - ${action.meta?.arg?.payment?.type}, amount: $${action.meta?.arg?.payment?.amount}`, { position: "bottom-right" }
            )
        })
        .addCase(createPaymentsBatch.pending, (state) => {
            state.loading = true
        })
        .addCase(createPaymentsBatch.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            toast.success(`${action.payload?.count || 0} payments recorded successfully.`, { position: "bottom-right" })
        })
        .addCase(createPaymentsBatch.rejected, (state, action) => {
            state.loading = false;
            const errorMessage = action.payload?.error || action.error?.message;
            state.error = errorMessage;
            toast.error(
              `Payments can't be created. Error - ${errorMessage}`, { position: "bottom-right" }
            )
        })
        .addCase(updatePaymentsBatch.pending, (state) => {
            state.loading = true
        })
        .addCase(updatePaymentsBatch.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            toast.success(`${action.payload?.count || 0} payments updated successfully.`, { position: "bottom-right" })
        })
        .addCase(updatePaymentsBatch.rejected, (state, action) => {
            state.loading = false;
            const errorMessage = action.payload?.error || action.error?.message;
            state.error = errorMessage;
            toast.error(
              `Payments can't be updated. Error - ${errorMessage}`, { position: "bottom-right" }
            )
        })
        .addCase(deletePayment.pending, (state) => {
          state.loading = true
        })
        .addCase(deletePayment.fulfilled, (state) => {
            state.loading = false;
            state.error = null;
            toast.success(`Payment deleted successfully.`, { position: "bottom-right" })
        })
        .addCase(deletePayment.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error?.message;
            toast.error(
              `Payment can't be deleted. Error - ${action.error?.message}. Arguments: id - ${action.meta?.arg?.id}`, { position: "bottom-right" }
            )
        })
    }
})

export const {} = paymentsSlice.actions;

export default paymentsSlice.reducer